<template>
   <div>
      <v-container>
         <v-dialog
            v-model="rolemodal"
            persistent
            width="500px"
            height="500px"
            @keydown.esc="cancel"
         >
            <v-sheet>
               <v-row no-gutters class="d-flex pa-0">
                  <v-col cols="12">
                     <v-toolbar dense :class="$globalstore.toolbar_headerclass">
                        <v-toolbar-title> Roles </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2">Cancel</v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2">OK</v-btn>
                     </v-toolbar>
                     <v-card class="overflow-y-auto">
                        <v-card-title>
                           <v-text-field
                              v-model="table_search"
                              append-icon="mdi-magnify"
                              label="Search"
                              single-line
                              hide-details
                           ></v-text-field>
                        </v-card-title>
                        <v-data-table
                           dense
                           ref="roletable"
                           :headers="data_headers"
                           :items="rolelist"
                           @click:row="rowClick"
                           item-key="role_id"
                           :search="table_search"
                           single-select
                        >
                        </v-data-table>
                     </v-card>
                  </v-col>
               </v-row>
            </v-sheet>
         </v-dialog>
      </v-container>
   </div>
</template>

<script>
   export default {
      props: {
         roledata: Array,
         dialogvisible: Boolean,
      },

      inject: ["ShowMessage"],

      data() {
         return {
            resolve: null,
            reject: null,
            selectedRole: null,
            roleRowIndex: -1,
            rolemodal: false,
            rolelist: [],
            table_search: "",
            roletable_row: null,
            data_headers: [
               {
                  text: "Name",
                  value: "role_name",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Description",
                  value: "role_description",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },
      watch: {
         dialogvisible: function(newval, oldval) {
            if (newval) {
               this.loadRoleList();
               this.rolemodal = true;
            }
         },
      },
      methods: {
         rowClick(item, row) {
            row.select(true);
            this.selectedRole = item;
         },

         async loadRoleList() {
            await this.$http({
               url: "/common/getrolelist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.rolelist = response.data.rolelist.filter((item) => {
                     return !this.roledata.some((x) => x.role_id === item.role_id);
                  });
               } else {
                  this.rolelist = [];
               }
            });
         },

         OkBtnClick() {
            this.rolemodal = false;
            this.$emit("save-selection", this.selectedRole);
         },
         cancelBtnClick() {
            this.rolemodal = false;
            this.selectedRole = null;
            this.$emit("cancel-selection");
         },
      },
   };
</script>
